module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"pdp-tab-base":{"collapsible-button":"Udvid sektion"}},"de":{"pdp-tab-base":{"collapsible-button":"Bereich erweitern"}},"fr":{"pdp-tab-base":{"collapsible-button":"Développer la section"}},"nl":{"pdp-tab-base":{"collapsible-button":"Sectie uitvouwen"}}}')
  delete Component.options._Ctor
}
